import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export function E500() {
  const { t } = useTranslation();

  return (
    <Result
      className={'h-screen'}
      status="500"
      title="500"
      subTitle={t('exception.500.subTitle')}
      extra={
        <div>
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('common.reload')}
          </Button>
        </div>
      }
    />
  );
}
